<script setup>
import ConfirmationModal from '@/components/ConfirmationModal.vue'
import { useGlobalStore } from '@/stores/GlobalStore'

const globalStore = useGlobalStore()

const handleAddAddress = (data) => {
  if (data) {
    globalStore.showAddressAlert = false
    globalStore.showAddressDialog = true
  } else {
    globalStore.showAddressAlert = false
  }
}
</script>
<template>
  <ConfirmationModal
    v-if="globalStore.showAddressAlert"
    :confirmationMessage="'Our payment processor requires a complete address. Please enter your home or business address.'"
    :confirmButtonText="'Add Address'"
    :confirmLabel="'Additional information is required.'"
    @confirmResult="handleAddAddress"
  />
</template>